import { render } from "./Bestsellers.vue?vue&type=template&id=09607b29&scoped=true"
import script from "./Bestsellers.vue?vue&type=script&lang=js"
export * from "./Bestsellers.vue?vue&type=script&lang=js"

import "./Bestsellers.vue?vue&type=style&index=0&id=09607b29&scoped=true&lang=css"
import "./Bestsellers.vue?vue&type=style&index=1&id=09607b29&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09607b29"]])

export default __exports__